class TabBlock {
    constructor(containerNode) {
        this.container = containerNode;
        this.activeDivClass = "tabs-block__content-item--active";
        this.activeButtonClass = "tabs-block__nav-item--active";
    }
    init() {
        if (this.container) {
            try {
                const tabNavs = this.container.querySelectorAll(
                    "button.js-btn-tab-nav"
                );
                const tabDivs =
                    this.container.querySelectorAll("div.js-tab-block");

                if (tabDivs.length === tabNavs.length) {
                    tabNavs.forEach((btn) => {
                        btn.addEventListener("click", () => {
                            tabNavs.forEach((b) =>
                                b.classList.remove(this.activeButtonClass)
                            );

                            const dataTab = btn.dataset.tab;

                            tabDivs.forEach((div) => {
                                div.classList.remove(this.activeDivClass);
                                if (div.dataset.tab === dataTab) {
                                    div.classList.add(this.activeDivClass);
                                    btn.classList.add(this.activeButtonClass);
                                }
                            });
                        });
                    });
                } else {
                }
            } catch (err) {
                console.error("Tab block error", err);
            }
        }
    }
}

export default TabBlock;
